var AdminSellerReq = (function() {
	var __private = {
		controlClass      : "seller-approved-section",
		reasonClass       : "seller-reason-section",
		popupClass        : "seller-approved-section__popup",

		textareaClss      : "reasonTextarea",

		enableButtonClass : "seller-enable-btn",
		disableButtonClass: "seller-disable-btn",

		disableLinkClass  : "seller-disable-reason",
		resetLinkClass    : "seller-disable-reset",

		disabledClass: "disabled",
		openClass    : "open",
		closeClass   : "close",

		dataset: {
			approved: "approved",
			sellerId: "sellerId"
		},
		actionAttr: "href",
		disabledButton: {
			0: "seller-disable-btn",
			1: "seller-enable-btn",
		},


		run() {
			if(document.querySelector(`.${this.controlClass}`) instanceof HTMLElement) {
				this.disableButtons();
				this.listener();
			}
		},

		disableButtons() {
			var sections = document.getElementsByClassName(this.controlClass);

			for (let i = 0; i < sections.length; i++) {
				const element = sections[i];
				let button;
				let approved;

				if(element instanceof HTMLElement) {
					approved = element.dataset[this.dataset.approved];

					if(approved !== undefined) {
						button = element.getElementsByClassName(this.disabledButton[approved])[0];

						if(button instanceof HTMLElement) button.classList.add(this.disabledClass);
					}
				}
			}
		},

		listener() {
			document.addEventListener("click", function(event) {
				event = event || window.event;
				var target = event.target;

				console.log('------------------------------------');
				console.log(target);
				console.log('------------------------------------');

				if(target instanceof HTMLElement) {
					// buttons
					if(target.classList.contains(__private.disableButtonClass) || target.classList.contains(__private.enableButtonClass)) {
						event.preventDefault();

						let parentTd = __private.getControl(target);
						let textarea = __private.getTextarea(target);

						console.log('------------------------------------');
						console.log(event);
						console.log('------------------------------------');

						// enable
						if(target.classList.contains(__private.enableButtonClass) && !target.classList.contains(__private.disabledClass)) {
							// request
							let url = __private.getUrl(target);
							let anotherBtn;

							// crear reason
							if(textarea instanceof HTMLElement) textarea.value = "";

							if(url) __private.request(url, target);
						} 
						
						// disable
						if(target.classList.contains(__private.disableButtonClass) && !target.classList.contains(__private.disabledClass)) {
							let popup = __private.getPopup(target);
							
							// textarea listener
							if(textarea instanceof HTMLElement) __private.textareaListener(textarea);

							if(parentTd instanceof HTMLElement) popup = parentTd.getElementsByClassName(__private.popupClass)[0];
							if(popup instanceof HTMLElement) {
								let disLink = popup.getElementsByClassName(__private.disableLinkClass)[0];
								if(disLink instanceof HTMLElement && textarea instanceof HTMLElement) {
									if(textarea.vlaue == " " || !textarea.value) disLink.classList.add(__private.disabledClass);
									else disLink.classList.remove(__private.disabledClass);
								}
								popup.classList.add(__private.openClass);
							}
						}
					}

					// links in popup
					if(target.classList.contains(__private.disableLinkClass) || target.classList.contains(__private.resetLinkClass)) {
						event.preventDefault();

						let popup = __private.getPopup(target);
						let textarea = __private.getTextarea(target);
						let reason = __private.getReason(target);

						// reset
						if(target.classList.contains(__private.resetLinkClass)) {
							if(textarea instanceof HTMLElement) textarea.value = "";
							if(reason instanceof HTMLElement) reason.textContent = "";
							if(popup instanceof HTMLElement) popup.classList.remove(__private.openClass);
						} 
						
						// disable
						if(target.classList.contains(__private.disableLinkClass) && !target.classList.contains(__private.disabledClass)) {
							let url = __private.getUrl(target);

							if(url) {
								if(reason instanceof HTMLElement && textarea instanceof HTMLElement)
									reason.textContent = textarea.value;

								if(popup instanceof HTMLElement) popup.classList.remove(__private.openClass);

								// sent request
								__private.request(url, target);
							}
						}
					}

					// popup 
					if(target.classList.contains(__private.closeClass)) {
						event.preventDefault();

						let popup = __private.getPopup(target);

						// close popup
						if(popup instanceof HTMLElement) popup.classList.remove(__private.openClass);
					}
				}
			});
		},

		textareaListener(textarea) {
			var popup = __private.getPopup(textarea);
			var disableButton;

			if(popup instanceof HTMLElement) disableButton = popup.getElementsByClassName(__private.disableLinkClass)[0];

			textarea.addEventListener("input", function() {
				var value = this.value;

				if(disableButton instanceof HTMLElement) {
					if(value.length > 0) disableButton.classList.remove(__private.disabledClass);
					else disableButton.classList.add(__private.disabledClass);
				}
			});
		},

		wait() {
			var sections = document.getElementsByClassName(this.controlClass);

			for (let i = 0; i < sections.length; i++) {
				const element = sections[i];
				let links;

				if(element instanceof HTMLElement) {
					links = element.getElementsByTagName("a");

					for (let j = 0; j < links.length; j++) {
						const l = links[j];
						l.classList.add(__private.disabledClass);
					}
				}
			}
		},

		waitEnd() {
			var sections = document.getElementsByClassName(this.controlClass);

			for (let i = 0; i < sections.length; i++) {
				const element = sections[i];
				let links;

				if(element instanceof HTMLElement) {
					links = element.getElementsByTagName("a");

					for (let j = 0; j < links.length; j++) {
						const l = links[j];
						l.classList.remove(__private.disabledClass);
					}
				}
			}
		},

		request(url, target) {
			var form;
			var data;
			var control = __private.getControl(target);
			var xhr = new XMLHttpRequest();

			form = searchElementByTagName(target, "FORM");

			if(form instanceof HTMLFormElement) {
				data = new FormData(form);
				// form.action = url;
				// form.submit();

				__private.wait();

				xhr.open("POST", url, true);
				xhr.send(data);
				xhr.onreadystatechange = function() {

					if (this.readyState === 4 && this.status === 200) {
						__private.toChange(control);
					} else {
						if(this.status >= 400) console.log("Error " + this.status);
					}
			
					setTimeout(() => {
						__private.waitEnd();

						setTimeout(() => {
							__private.disableButtons();
						}, 0);
					}, 100);

				};
			}
		},

		getControl(el) {
			return searchElementByClassName(el, __private.controlClass);
		},

		getPopup(el) {
			return searchElementByClassName(el, __private.popupClass);
		},

		getTextarea(el) {
			var control = __private.getControl(el);
			var popup = __private.getPopup(el);
			var textarea = false;

			if(popup instanceof HTMLElement) textarea = popup.getElementsByTagName("textarea")[0];
			else if(control instanceof HTMLElement) textarea = control.getElementsByTagName("textarea")[0];

			if(!textarea instanceof HTMLTextAreaElement) textarea = false;

			return textarea;
		},

		getReason(el) {
			var control = __private.getControl(el);
			var reason = false;
			var dataId = undefined;

			if(control instanceof HTMLElement) dataId = control.dataset[__private.dataset.sellerId];

			if(dataId !== undefined) {
				reason = document.querySelector(`.${__private.reasonClass}[data-seller-id='${dataId}']`);

				if(!reason instanceof HTMLElement) reason = false;
			}

			return reason;
		},

		getUrl(el) {
			var url  = false;
			var href = false;
			var control = __private.getControl(el);
			var ID = false;

			if(el instanceof HTMLElement && el.getAttribute("href"))
				href = el.href;

			if(control instanceof HTMLElement && control.dataset[__private.dataset.sellerId])
				ID = control.dataset[__private.dataset.sellerId];

			//if(href && ID) url = `${href}&id=${ID}`;
			if(href) url = `${href}`;

			return url;
		},

		toChange(control) {
			var appr;

			if(control instanceof HTMLElement && control.dataset[__private.dataset.approved] !== undefined) {
				appr = control.dataset[__private.dataset.approved];

				if(+appr === 1) control.dataset[__private.dataset.approved] = 0;
				else control.dataset[__private.dataset.approved] = 1;
			}
		}
	};

	return {
		init() {
			__private.run();
		}
	};
})();


(function() {
	document.addEventListener("DOMContentLoaded", function() {
		if(document.getElementById("admin")) AdminSellerReq.init();
	});
})();